import ts from 'typescript';
import * as utils from './utils';
export function getNameNode(node) {
    return utils.getValueOrUndefined(node.name);
}
export function getNameNodeOrThrow(node) {
    return utils.throwIfNullOrUndefined(getNameNode(node), 'name');
}
export function getName(node) {
    const name = getNameNode(node);
    if (name === undefined || ts.isObjectBindingPattern(name) || ts.isArrayBindingPattern(name)) {
        return undefined;
    }
    return name.getText();
}
export function getNameOrThrow(node) {
    return utils.throwIfNullOrUndefined(getName(node), 'name');
}
export function getPropertyNameNode(node) {
    return utils.getValueOrUndefined(node.propertyName);
}
export function getDotDotDotToken(node) {
    return utils.getValueOrUndefined(node.dotDotDotToken);
}
export function getText(node) {
    return node.getText();
}
export function getParentSyntaxList(node) {
    const parent = utils.getValueOrUndefined(node.parent);
    if (parent === undefined) {
        return undefined;
    }
    const { pos, end } = node;
    for (const child of parent.getChildren()) {
        if (child.pos > end || child === node) {
            return undefined;
        }
        if (child.kind === ts.SyntaxKind.SyntaxList && child.pos <= pos && child.end >= end) {
            return child;
        }
    }
    return undefined;
}
export function getParent(node) {
    const parent = utils.getValueOrUndefined(node.parent);
    return parent === undefined ? undefined : node.parent;
}
export function* getAncestors(node) {
    let parent = getParent(node);
    while (parent !== undefined) {
        yield parent;
        parent = getParent(parent);
    }
}
export function* getDescendants(node) {
    let children = getChildren(node);
    while (children.length > 0) {
        const mutableNextChildren = [];
        for (const child of children) {
            yield child;
            mutableNextChildren.push(...getChildren(child));
        }
        children = mutableNextChildren;
    }
}
export function* getDescendantsByKind(node, kind) {
    for (const descendant of getDescendants(node)) {
        if (descendant.kind === kind) {
            yield descendant;
        }
    }
}
function getTarget(symbol) {
    const target = symbol.target;
    return target === undefined ? symbol : target;
}
export function getSymbol(typeChecker, node) {
    const symbol = utils.getValueOrUndefined(node.symbol);
    if (symbol !== undefined) {
        return getTarget(symbol);
    }
    const typeCheckerSymbol = utils.getValueOrUndefined(typeChecker.getSymbolAtLocation(node));
    if (typeCheckerSymbol !== undefined) {
        return getTarget(typeCheckerSymbol);
    }
    const nameNode = getNameNode(node);
    if (nameNode !== undefined) {
        return getSymbol(typeChecker, nameNode);
    }
    return undefined;
}
export function getSymbolOrThrow(typeChecker, node) {
    return utils.throwIfNullOrUndefined(getSymbol(typeChecker, node), 'symbol');
}
function getChildren(node) {
    return node.getChildren();
}
export function getFirstChild(node) {
    const children = getChildren(node);
    return utils.getValueOrUndefined(children[0]);
}
export function getFirstChildByKind(node, kind) {
    const children = getChildren(node);
    return children.find((value) => value.kind === kind);
}
export function getFirstAncestorByKind(node, kind) {
    for (const ancestor of getAncestors(node)) {
        if (ancestor.kind === kind) {
            return ancestor;
        }
    }
    return undefined;
}
export function getFirstAncestorByKindOrThrow(node, kind) {
    return utils.throwIfNullOrUndefined(getFirstAncestorByKind(node, kind), 'ancestor');
}
export function getFirstAncestorByTest(node, isNode) {
    for (const ancestor of getAncestors(node)) {
        if (isNode(ancestor)) {
            return ancestor;
        }
    }
    return undefined;
}
export function getFirstAncestorByTestOrThrow(node, isNode) {
    return utils.throwIfNullOrUndefined(getFirstAncestorByTest(node, isNode), 'ancestor');
}
export function getFirstDescendantByKind(node, kind) {
    for (const ancestor of getDescendants(node)) {
        if (ancestor.kind === kind) {
            return ancestor;
        }
    }
    return undefined;
}
function hasNodeFlag(node, flag) {
    return (node.flags & flag) !== 0;
}
export function isGlobalAugmentation(node) {
    return hasNodeFlag(node, ts.NodeFlags.GlobalAugmentation);
}
export function getSourceFile(node) {
    return node.getSourceFile();
}
export function getPos(node) {
    return node.pos;
}
export function getEnd(node) {
    return node.end;
}
export function getChildAtPos(node, pos) {
    if (pos < getPos(node) || pos >= getEnd(node)) {
        return undefined;
    }
    return getChildren(node).find((child) => pos >= getPos(child) && pos < getEnd(child));
}
export function getDescendantAtPos(nodeIn, pos) {
    let node;
    while (true) {
        const nextNode = getChildAtPos(node === undefined ? nodeIn : node, pos);
        if (nextNode === undefined) {
            return node;
        }
        node = nextNode;
    }
}
export function isPartOfTypeNode(node) {
    return ts.isPartOfTypeNode(node);
}

//# sourceMappingURL=node.js.map
